import { useEffect } from "react"
import { Dropdown } from "react-bootstrap"

type ActionDropdownProps = {
    items: Array<{
        text: string
        eventHandler: () => void
        additionalClass?: string
        additionalElement?: JSX.Element
    }>
}

const ActionDropdown = ({ items }: ActionDropdownProps) => {
    return (
        <>
            <Dropdown className="dropdown rounded-xl border border-jacarta-100 bg-white hover:bg-jacarta-100 dark:border-gray-400 dark:bg-gray-900 dark:hover:bg-jacarta-500 dark:hover:border-transparent">
                <Dropdown.Toggle className="dropdown-toggle inline-flex h-10 w-10 items-center justify-center text-sm fill-gray-400 hover:fill-white">
                    <svg
                        width="16"
                        height="4"
                        viewBox="0 0 16 4"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2" cy="2" r="2"></circle>
                        <circle cx="8" cy="2" r="2"></circle>
                        <circle cx="14" cy="2" r="2"></circle>
                    </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu dropdown-menu-end z-10 hidden min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl dark:bg-gray-900">
                    {
                        items.map(({ eventHandler, text, additionalClass, additionalElement }, index) => (
                            <div key={index}>
                                <Dropdown.Item
                                    className={`block w-full rounded-xl px-5 py-2 text-left font-display text-sm transition-colors hover:bg-jacarta-50 dark:hover:bg-jacarta-600 ${additionalClass || "dark:text-white"}`}
                                    onClick={eventHandler}
                                >
                                    {text}
                                </Dropdown.Item>
                                {additionalElement}
                            </div>
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default ActionDropdown